/**
 * Worker do pdf.js BUNDLADO LOCAL (mesmo contrato do signing-workbench, D-063 item 1:
 * "worker bundlado LOCAL — nada de CDN"). O `?url` do Vite resolve o arquivo como asset do
 * próprio build (copiado para `dist/assets/`), nunca busca em `cdnjs`/`unpkg` — diferente do
 * exemplo "rápido" da documentação do pdf.js, que aponta para um CDN por padrão.
 *
 * Importar este módulo (side-effect only) ANTES de qualquer `getDocument(...)`.
 */
import { GlobalWorkerOptions } from 'pdfjs-dist';
// eslint-disable-next-line import/no-unresolved
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

GlobalWorkerOptions.workerSrc = pdfWorkerUrl;
